import { render, staticRenderFns } from "./Facerecognition.vue?vue&type=template&id=eab27cb2&scoped=true&"
import script from "./Facerecognition.vue?vue&type=script&lang=js&"
export * from "./Facerecognition.vue?vue&type=script&lang=js&"
import style0 from "./Facerecognition.vue?vue&type=style&index=0&id=eab27cb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab27cb2",
  null
  
)

export default component.exports